/**
 * 졸업대장 데이터
 */
const GraduationRegisterData = [
            {
                "book_id" : 10423,
                "book_title" : "(馬山高等女學校) 卒業證書臺帳 1915年度 以降",
                "book_title_ko" : "(마산고등여학교) 졸업증서대장 1915년도 이강",
                "publish_date" : "1915.04.28",
                "publish_year" : 1915,
                "publish_month" : 4,
                "publish_day" : 28,
                "publisher" : "馬山公立高等女學校",
                "publisher_ko" : "마산공립고등여학교",
                "library" : "○",
                "school_id" : 52945,
                "primaryname" : "馬山公立高等女學校",
                "primaryname_ko" : "마산공립고등여학교"
            },
            {
                "book_id" : 10423,
                "book_title" : "(馬山高等女學校) 卒業證書臺帳 1915年度 以降",
                "book_title_ko" : "(마산고등여학교) 졸업증서대장 1915년도 이강",
                "publish_date" : "1915.04.28",
                "publish_year" : 1915,
                "publish_month" : 4,
                "publish_day" : 28,
                "publisher" : "馬山公立高等女學校",
                "publisher_ko" : "마산공립고등여학교",
                "library" : "○",
                "school_id" : 52787,
                "primaryname" : "馬山高等女學校",
                "primaryname_ko" : "마산고등여학교"
            },
            {
                "book_id" : 10424,
                "book_title" : "(仁川高等女學校) 卒業臺帳 (1912~1946)",
                "book_title_ko" : "(인천고등여학교) 졸업대장 (1912~1946)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "仁川公立高等女學校",
                "publisher_ko" : "인천공립고등여학교",
                "library" : "△",
                "school_id" : 52946,
                "primaryname" : "仁川公立高等女學校",
                "primaryname_ko" : "인천공립고등여학교"
            },
            {
                "book_id" : 10424,
                "book_title" : "(仁川高等女學校) 卒業臺帳 (1912~1946)",
                "book_title_ko" : "(인천고등여학교) 졸업대장 (1912~1946)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "仁川公立高等女學校",
                "publisher_ko" : "인천공립고등여학교",
                "library" : "△",
                "school_id" : 52788,
                "primaryname" : "仁川高等女學校",
                "primaryname_ko" : "인천고등여학교"
            },
            {
                "book_id" : 10547,
                "book_title" : "(公州高等普通學校) 卒業臺帳 (충남공주고등학교)",
                "book_title_ko" : "(공주고등보통학교) 졸업대장 (충남공주고등학교)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "公州公立高等普通學校",
                "publisher_ko" : "공주공립고등보통학교",
                "library" : "○",
                "school_id" : 52957,
                "primaryname" : "公州公立高等普通學校",
                "primaryname_ko" : "공주공립고등보통학교"
            },
            {
                "book_id" : 10547,
                "book_title" : "(公州高等普通學校) 卒業臺帳 (충남공주고등학교)",
                "book_title_ko" : "(공주고등보통학교) 졸업대장 (충남공주고등학교)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "公州公立高等普通學校",
                "publisher_ko" : "공주공립고등보통학교",
                "library" : "○",
                "school_id" : 52804,
                "primaryname" : "公州高等普通學校",
                "primaryname_ko" : "공주고등보통학교"
            },
            {
                "book_id" : 10548,
                "book_title" : "(公州高等女學校) 卒業證書臺帳 ",
                "book_title_ko" : "(공주고등여학교) 졸업증서대장 ",
                "publish_date" : "1945.03.00",
                "publish_year" : 1945,
                "publish_month" : 3,
                "publish_day" : 0,
                "publisher" : "公州公立高等女學校",
                "publisher_ko" : "공주공립고등여학교",
                "library" : "○",
                "school_id" : 52958,
                "primaryname" : "公州公立高等女學校",
                "primaryname_ko" : "공주공립고등여학교"
            },
            {
                "book_id" : 10548,
                "book_title" : "(公州高等女學校) 卒業證書臺帳 ",
                "book_title_ko" : "(공주고등여학교) 졸업증서대장 ",
                "publish_date" : "1945.03.00",
                "publish_year" : 1945,
                "publish_month" : 3,
                "publish_day" : 0,
                "publisher" : "公州公立高等女學校",
                "publisher_ko" : "공주공립고등여학교",
                "library" : "○",
                "school_id" : 52819,
                "primaryname" : "公州高等女學校",
                "primaryname_ko" : "공주고등여학교"
            },
            {
                "book_id" : 10549,
                "book_title" : "(光州高等普通學校) 卒業臺帳 (1925~1941)",
                "book_title_ko" : "(광주고등보통학교) 졸업대장 (1925~1941)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "光州公立高等普通學校",
                "publisher_ko" : "광주공립고등보통학교",
                "library" : "○",
                "school_id" : 52956,
                "primaryname" : "光州公立高等普通學校",
                "primaryname_ko" : "광주공립고등보통학교"
            },
            {
                "book_id" : 10549,
                "book_title" : "(光州高等普通學校) 卒業臺帳 (1925~1941)",
                "book_title_ko" : "(광주고등보통학교) 졸업대장 (1925~1941)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "光州公立高等普通學校",
                "publisher_ko" : "광주공립고등보통학교",
                "library" : "○",
                "school_id" : 52807,
                "primaryname" : "光州高等普通學校",
                "primaryname_ko" : "광주고등보통학교"
            },
            {
                "book_id" : 10550,
                "book_title" : "(東萊高等普通學校) 卒業證書臺帳 (冊中1号)",
                "book_title_ko" : "(동래고등보통학교) 졸업증서대장 (책중1호)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "東萊高等普通學校",
                "publisher_ko" : "동래고등보통학교",
                "library" : "△",
                "school_id" : 19032,
                "primaryname" : "東萊高等普通學校",
                "primaryname_ko" : "동래고등보통학교"
            },
            {
                "book_id" : 10550,
                "book_title" : "(東萊高等普通學校) 卒業證書臺帳 (冊中1号)",
                "book_title_ko" : "(동래고등보통학교) 졸업증서대장 (책중1호)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "東萊高等普通學校",
                "publisher_ko" : "동래고등보통학교",
                "library" : "△",
                "school_id" : 52820,
                "primaryname" : "東萊高等普通學校",
                "primaryname_ko" : "동래고등보통학교"
            },
            {
                "book_id" : 10551,
                "book_title" : "(全州高等普通學校) 卒業臺帳 (1-22回)",
                "book_title_ko" : "(전주고등보통학교) 졸업대장 (1-22회)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "全州公立高等普通學校",
                "publisher_ko" : "전주공립고등보통학교",
                "library" : "○",
                "school_id" : 52959,
                "primaryname" : "全州公立高等普通學校",
                "primaryname_ko" : "전주공립고등보통학교"
            },
            {
                "book_id" : 10551,
                "book_title" : "(全州高等普通學校) 卒業臺帳 (1-22回)",
                "book_title_ko" : "(전주고등보통학교) 졸업대장 (1-22회)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "全州公立高等普通學校",
                "publisher_ko" : "전주공립고등보통학교",
                "library" : "○",
                "school_id" : 52821,
                "primaryname" : "全州高等普通學校",
                "primaryname_ko" : "전주고등보통학교"
            },
            {
                "book_id" : 10552,
                "book_title" : "(晋州高等普通學校) 卒業臺帳 1930~1944年",
                "book_title_ko" : "(진주고등보통학교) 졸업대장 1930~1944년",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "晋州公立高等普通學校",
                "publisher_ko" : "진주공립고등보통학교",
                "library" : "○",
                "school_id" : 52960,
                "primaryname" : "晋州公立高等普通學校",
                "primaryname_ko" : "진주공립고등보통학교"
            },
            {
                "book_id" : 10552,
                "book_title" : "(晋州高等普通學校) 卒業臺帳 1930~1944年",
                "book_title_ko" : "(진주고등보통학교) 졸업대장 1930~1944년",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "晋州公立高等普通學校",
                "publisher_ko" : "진주공립고등보통학교",
                "library" : "○",
                "school_id" : 52822,
                "primaryname" : "晋州高等普通學校",
                "primaryname_ko" : "진주고등보통학교"
            },
            {
                "book_id" : 10713,
                "book_title" : "(公州農業學校) 卒業臺帳 (1937~1945)",
                "book_title_ko" : "(공주농업학교) 졸업대장 (1937~1945)",
                "publish_date" : "1946.00.00",
                "publish_year" : 1946,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "公州農業學校",
                "publisher_ko" : "공주농업학교",
                "library" : "○",
                "school_id" : 27374,
                "primaryname" : "公州農業學校",
                "primaryname_ko" : "공주농업학교"
            },
            {
                "book_id" : 10713,
                "book_title" : "(公州農業學校) 卒業臺帳 (1937~1945)",
                "book_title_ko" : "(공주농업학교) 졸업대장 (1937~1945)",
                "publish_date" : "1946.00.00",
                "publish_year" : 1946,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "公州農業學校",
                "publisher_ko" : "공주농업학교",
                "library" : "○",
                "school_id" : 52853,
                "primaryname" : "公州農業學校",
                "primaryname_ko" : "공주농업학교"
            },
            {
                "book_id" : 10714,
                "book_title" : "(忠淸南道農業學校) 卒業證書交付簿 (1925年도 以後)",
                "book_title_ko" : "(충청남도농업학교) 졸업증서교부부 (1925년도 이후)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "忠淸南道公立農業學校",
                "publisher_ko" : "충청남도공립농업학교",
                "library" : "○",
                "school_id" : 52966,
                "primaryname" : "忠淸南道公立農業學校",
                "primaryname_ko" : "충청남도공립농업학교"
            },
            {
                "book_id" : 10714,
                "book_title" : "(忠淸南道農業學校) 卒業證書交付簿 (1925年도 以後)",
                "book_title_ko" : "(충청남도농업학교) 졸업증서교부부 (1925년도 이후)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "忠淸南道公立農業學校",
                "publisher_ko" : "충청남도공립농업학교",
                "library" : "○",
                "school_id" : 52841,
                "primaryname" : "忠淸南道農業學校",
                "primaryname_ko" : "충청남도농업학교"
            },
            {
                "book_id" : 10715,
                "book_title" : "(金海農業學校) 卒業證書臺帳 1930~1945年",
                "book_title_ko" : "(금해농업학교) 졸업증서대장 1930~1945년",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "金海公立農業學校",
                "publisher_ko" : "금해공립농업학교",
                "library" : "○",
                "school_id" : 52967,
                "primaryname" : "金海公立農業學校",
                "primaryname_ko" : "금해공립농업학교"
            },
            {
                "book_id" : 10715,
                "book_title" : "(金海農業學校) 卒業證書臺帳 1930~1945年",
                "book_title_ko" : "(금해농업학교) 졸업증서대장 1930~1945년",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "金海公立農業學校",
                "publisher_ko" : "금해공립농업학교",
                "library" : "○",
                "school_id" : 52854,
                "primaryname" : "金海農業學校",
                "primaryname_ko" : "김해농업학교"
            },
            {
                "book_id" : 10716,
                "book_title" : "(大丘農林學校) 卒業臺帳 (1回~33回)",
                "book_title_ko" : "(대구농림학교) 졸업대장 (1회~33회)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "大丘公立農林學校",
                "publisher_ko" : "대구공립농림학교",
                "library" : "△",
                "school_id" : 52968,
                "primaryname" : "大丘公立農林學校",
                "primaryname_ko" : "대구공립농림학교"
            },
            {
                "book_id" : 10716,
                "book_title" : "(大丘農林學校) 卒業臺帳 (1回~33回)",
                "book_title_ko" : "(대구농림학교) 졸업대장 (1회~33회)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "大丘公立農林學校",
                "publisher_ko" : "대구공립농림학교",
                "library" : "△",
                "school_id" : 52855,
                "primaryname" : "大丘農林學校",
                "primaryname_ko" : "대구농림학교"
            },
            {
                "book_id" : 10717,
                "book_title" : "(大丘商業學校) 卒業臺帳 1928(第1回)~1945(第19回)",
                "book_title_ko" : "(대구상업학교) 졸업대장 1928(제1회)~1945(제19회)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "大丘公立商業學校",
                "publisher_ko" : "대구공립상업학교",
                "library" : "△",
                "school_id" : 52969,
                "primaryname" : "大丘公立商業學校",
                "primaryname_ko" : "대구공립상업학교"
            },
            {
                "book_id" : 10717,
                "book_title" : "(大丘商業學校) 卒業臺帳 1928(第1回)~1945(第19回)",
                "book_title_ko" : "(대구상업학교) 졸업대장 1928(제1회)~1945(제19회)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "大丘公立商業學校",
                "publisher_ko" : "대구공립상업학교",
                "library" : "△",
                "school_id" : 52856,
                "primaryname" : "大丘商業學校",
                "primaryname_ko" : "대구상업학교"
            },
            {
                "book_id" : 10718,
                "book_title" : "(馬山商業高等學校) 卒業證書臺帳 自檀紀4258年 第1回~至檀紀4278年 第20回",
                "book_title_ko" : "(마산상업고등학교) 졸업증서대장 자단기4258년 제1회~지단기4278년 제20회",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "馬山商業高等學校",
                "publisher_ko" : "마산상업고등학교",
                "library" : "○",
                "school_id" : 52970,
                "primaryname" : "馬山商業高等學校",
                "primaryname_ko" : "마산상업고등학교"
            },
            {
                "book_id" : 10718,
                "book_title" : "(馬山商業高等學校) 卒業證書臺帳 自檀紀4258年 第1回~至檀紀4278年 第20回",
                "book_title_ko" : "(마산상업고등학교) 졸업증서대장 자단기4258년 제1회~지단기4278년 제20회",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "馬山商業高等學校",
                "publisher_ko" : "마산상업고등학교",
                "library" : "○",
                "school_id" : 52857,
                "primaryname" : "馬山商業高等學校",
                "primaryname_ko" : "마산상업고등학교"
            },
            {
                "book_id" : 10719,
                "book_title" : "(仁川商業學校) 卒業臺帳 (1916~1935)",
                "book_title_ko" : "(인천상업학교) 졸업대장 (1916~1935)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "仁川公立商業學校",
                "publisher_ko" : "인천공립상업학교",
                "library" : "○",
                "school_id" : 52971,
                "primaryname" : "仁川公立商業學校",
                "primaryname_ko" : "인천공립상업학교"
            },
            {
                "book_id" : 10719,
                "book_title" : "(仁川商業學校) 卒業臺帳 (1916~1935)",
                "book_title_ko" : "(인천상업학교) 졸업대장 (1916~1935)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "仁川公立商業學校",
                "publisher_ko" : "인천공립상업학교",
                "library" : "○",
                "school_id" : 52858,
                "primaryname" : "仁川商業學校",
                "primaryname_ko" : "인천상업학교"
            },
            {
                "book_id" : 10720,
                "book_title" : "(仁川商業學校) 卒業臺帳 (1936~1943)",
                "book_title_ko" : "(인천상업학교) 졸업대장 (1936~1943)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "仁川公立商業學校",
                "publisher_ko" : "인천공립상업학교",
                "library" : "",
                "school_id" : 52971,
                "primaryname" : "仁川公立商業學校",
                "primaryname_ko" : "인천공립상업학교"
            },
            {
                "book_id" : 10720,
                "book_title" : "(仁川商業學校) 卒業臺帳 (1936~1943)",
                "book_title_ko" : "(인천상업학교) 졸업대장 (1936~1943)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "仁川公立商業學校",
                "publisher_ko" : "인천공립상업학교",
                "library" : "",
                "school_id" : 52858,
                "primaryname" : "仁川商業學校",
                "primaryname_ko" : "인천상업학교"
            },
            {
                "book_id" : 10721,
                "book_title" : "(仁川商業學校) 卒業臺帳 (1944~1948)",
                "book_title_ko" : "(인천상업학교) 졸업대장 (1944~1948)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "仁川公立商業學校",
                "publisher_ko" : "인천공립상업학교",
                "library" : "",
                "school_id" : 52971,
                "primaryname" : "仁川公立商業學校",
                "primaryname_ko" : "인천공립상업학교"
            },
            {
                "book_id" : 10721,
                "book_title" : "(仁川商業學校) 卒業臺帳 (1944~1948)",
                "book_title_ko" : "(인천상업학교) 졸업대장 (1944~1948)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "仁川公立商業學校",
                "publisher_ko" : "인천공립상업학교",
                "library" : "",
                "school_id" : 52858,
                "primaryname" : "仁川商業學校",
                "primaryname_ko" : "인천상업학교"
            },
            {
                "book_id" : 10722,
                "book_title" : "(晋州農業學校) 卒業臺帳 1~32回(1912~1945)",
                "book_title_ko" : "(진주농업학교) 졸업대장 1~32회(1912~1945)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "晋州公立農業學校",
                "publisher_ko" : "진주공립농업학교",
                "library" : "○",
                "school_id" : 37824,
                "primaryname" : "晋州公立農業學校",
                "primaryname_ko" : "진주공립농업학교"
            },
            {
                "book_id" : 10722,
                "book_title" : "(晋州農業學校) 卒業臺帳 1~32回(1912~1945)",
                "book_title_ko" : "(진주농업학교) 졸업대장 1~32회(1912~1945)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "晋州公立農業學校",
                "publisher_ko" : "진주공립농업학교",
                "library" : "○",
                "school_id" : 52859,
                "primaryname" : "晋州農業學校",
                "primaryname_ko" : "진주농업학교"
            },
            {
                "book_id" : 10723,
                "book_title" : "(天安農業學校) 卒業臺帳 (1932~1945)",
                "book_title_ko" : "(천안농업학교) 졸업대장 (1932~1945)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "天安公立農業學校",
                "publisher_ko" : "천안공립농업학교",
                "library" : "○",
                "school_id" : 52972,
                "primaryname" : "天安公立農業學校",
                "primaryname_ko" : "천안공립농업학교"
            },
            {
                "book_id" : 10723,
                "book_title" : "(天安農業學校) 卒業臺帳 (1932~1945)",
                "book_title_ko" : "(천안농업학교) 졸업대장 (1932~1945)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "天安公立農業學校",
                "publisher_ko" : "천안공립농업학교",
                "library" : "○",
                "school_id" : 52860,
                "primaryname" : "天安農業學校",
                "primaryname_ko" : "천안농업학교"
            },
            {
                "book_id" : 10724,
                "book_title" : "(統營水産學校) 卒業臺帳 (1922~1945)",
                "book_title_ko" : "(통영수산학교) 졸업대장 (1922~1945)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "統營水産高等專門學校",
                "publisher_ko" : "통영수산고등전문학교",
                "library" : "○",
                "school_id" : 52973,
                "primaryname" : "統營水産高等專門學校",
                "primaryname_ko" : "통영수산고등전문학교"
            },
            {
                "book_id" : 10724,
                "book_title" : "(統營水産學校) 卒業臺帳 (1922~1945)",
                "book_title_ko" : "(통영수산학교) 졸업대장 (1922~1945)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "統營水産高等專門學校",
                "publisher_ko" : "통영수산고등전문학교",
                "library" : "○",
                "school_id" : 52861,
                "primaryname" : "統營水産學校",
                "primaryname_ko" : "통영수산학교"
            },
            {
                "book_id" : 10789,
                "book_title" : "(一新女子高等普通學校) 卒業臺帳 (1928~1948)",
                "book_title_ko" : "(일신여자고등보통학교) 졸업대장 (1928~1948)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "一新女子高等普通學校",
                "publisher_ko" : "일신녀자고등보통학교",
                "library" : "○",
                "school_id" : 52992,
                "primaryname" : "一新女子高等普通學校",
                "primaryname_ko" : "일신녀자고등보통학교"
            },
            {
                "book_id" : 10789,
                "book_title" : "(一新女子高等普通學校) 卒業臺帳 (1928~1948)",
                "book_title_ko" : "(일신여자고등보통학교) 졸업대장 (1928~1948)",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "一新女子高等普通學校",
                "publisher_ko" : "일신녀자고등보통학교",
                "library" : "○",
                "school_id" : 52888,
                "primaryname" : "一新女子高等普通學校",
                "primaryname_ko" : "일신여자고등보통학교(진주)"
            },
            {
                "book_id" : 10790,
                "book_title" : "(全州女子高等普通學校) 卒業證書臺帳 1930年~1945年",
                "book_title_ko" : "(전주여자고등보통학교) 졸업증서대장 1930년~1945년",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "全州公立女子高等普通學校",
                "publisher_ko" : "전주공립녀자고등보통학교",
                "library" : "○",
                "school_id" : 52993,
                "primaryname" : "全州公立女子高等普通學校",
                "primaryname_ko" : "전주공립녀자고등보통학교"
            },
            {
                "book_id" : 10790,
                "book_title" : "(全州女子高等普通學校) 卒業證書臺帳 1930年~1945年",
                "book_title_ko" : "(전주여자고등보통학교) 졸업증서대장 1930년~1945년",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "全州公立女子高等普通學校",
                "publisher_ko" : "전주공립녀자고등보통학교",
                "library" : "○",
                "school_id" : 52892,
                "primaryname" : "全州女子高等普通學校",
                "primaryname_ko" : "전주여자고등보통학교"
            },
            {
                "book_id" : 10967,
                "book_title" : "(公州中學校) 卒業臺帳 ",
                "book_title_ko" : "(공주중학교) 졸업대장 ",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "公州公立中學校",
                "publisher_ko" : "공주공립중학교",
                "library" : "○",
                "school_id" : 53008,
                "primaryname" : "公州公立中學校",
                "primaryname_ko" : "공주공립중학교"
            },
            {
                "book_id" : 10967,
                "book_title" : "(公州中學校) 卒業臺帳 ",
                "book_title_ko" : "(공주중학교) 졸업대장 ",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "公州公立中學校",
                "publisher_ko" : "공주공립중학교",
                "library" : "○",
                "school_id" : 52932,
                "primaryname" : "公州中學校",
                "primaryname_ko" : "공주중학교"
            },
            {
                "book_id" : 10968,
                "book_title" : "(大邱中學校) 倭政時卒業生臺帳 1925年起",
                "book_title_ko" : "(대구중학교) 왜정시졸업생대장 1925년기",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "大邱中學校",
                "publisher_ko" : "대구중학교",
                "library" : "△",
                "school_id" : 27242,
                "primaryname" : "大邱中學校",
                "primaryname_ko" : "대구중학교"
            },
            {
                "book_id" : 10968,
                "book_title" : "(大邱中學校) 倭政時卒業生臺帳 1925年起",
                "book_title_ko" : "(대구중학교) 왜정시졸업생대장 1925년기",
                "publish_date" : "........",
                "publish_year" : 0,
                "publish_month" : 0,
                "publish_day" : 0,
                "publisher" : "大邱中學校",
                "publisher_ko" : "대구중학교",
                "library" : "△",
                "school_id" : 52933,
                "primaryname" : "大邱中學校",
                "primaryname_ko" : "대구중학교"
            }
]

export default GraduationRegisterData;